import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";


class TippedIcon extends React.PureComponent {
    render() {
        return (
          <span onClick={this.props.onTooltipClicked} style={{ display: "flex", alignItems: "center" }}>
            <Tooltip
              title={this.props.tooltipText}
              placement={this.props.tooltipPopoutDirection}
            >
              <span className="tipped-icon-tooltip-container" style={{ display: "flex", alignItems: "center" }}>
                  <i className={`md-icon material-icons ${this.props.iconClassName}`}>{this.props.iconName}</i>
              </span>
            </Tooltip>
          </span>
        );
    }
}

TippedIcon.defaultProps = {
    tooltipText: "No Tooltip Text Entered",
    iconName: "stop",
    iconClassName: "",
    tooltipPopoutDirection: "top",
    onTooltipClicked: null,
};

TippedIcon.propTypes = {
    tooltipText: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    iconClassName: PropTypes.string,
    tooltipPopoutDirection: PropTypes.string,
    onTooltipClicked: PropTypes.func,
};

export default TippedIcon;